// This will be set at build time via Vite
export const APP_VERSION = import.meta.env.VITE_SENTRY_RELEASE || "development";
export const GIT_SHA = APP_VERSION.split("@")[1]?.split("-")[1] || "unknown";
export const ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT || "development";
export const BUILD_TIME = import.meta.env.VITE_BUILD_TIME || new Date().toISOString();

// Helper function to get formatted version info
export const getVersionInfo = () => {
  return {
    version: APP_VERSION,
    gitSha: GIT_SHA,
    environment: ENVIRONMENT,
    buildTime: BUILD_TIME,
    isDevelopment: import.meta.env.DEV,
    isProduction: import.meta.env.PROD,
  };
};

// Helper function to get human-readable version string
export const getVersionString = () => {
  if (ENVIRONMENT === "development") {
    return `Development (${GIT_SHA})`;
  }

  return `${ENVIRONMENT} (${GIT_SHA.substring(0, 7)})`;
};

// Log version info on import (development only)
if (import.meta.env.DEV) {
  console.log("🚀 App Version:", getVersionString());
  console.log("📦 Build Info:", getVersionInfo());
}